import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import ReactDOM from 'react-dom';
import { loadableReady } from '@loadable/component';
import { App } from './App';
import { WithABProvider } from './WithABProvider';
export const BootReact = ({ CAPI }) => {
    loadableReady(() => {
        ReactDOM.render(_jsx(WithABProvider, Object.assign({ abTestSwitches: CAPI.config.switches, pageIsSensitive: CAPI.config.isSensitive, isDev: CAPI.config.isDev }, { children: _jsx(App, { CAPI: CAPI }, void 0) }), void 0), document.getElementById('react-root'));
    }).catch((e) => console.error(`BootReact @loadable/component - error: ${e}`));
};
